import { render } from "./CompanyManage.vue?vue&type=template&id=48e1164e&scoped=true"
import script from "./CompanyManage.vue?vue&type=script&lang=js"
export * from "./CompanyManage.vue?vue&type=script&lang=js"

import "./CompanyManage.vue?vue&type=style&index=0&id=48e1164e&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e1164e"]])

export default __exports__